import { withInstall } from '../../utils/install';
import Icon from './index.vue';

export const IvueIcon = withInstall(Icon);
export default IvueIcon;

export * from './index.vue';
